import { Node, mergeAttributes } from '@tiptap/core'

export const CaretAnchor = Node.create({
  name: 'caretAnchor',

  group: 'inline',

  inline: true,

  addAttributes() {
    return {
      class: {
        default: 'caret-anchor',
        parseHTML: element => element.getAttribute('class'),
        renderHTML: attributes => {
          return {
            class: attributes.class || 'caret-anchor'
          }
        }
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span.caret-anchor'
      }
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes, { class: 'caret-anchor' }), '\u200B'] // Zero-width space
  }
})
